<template>
    <v-container>   
        <v-row>
            <v-col cols="12">
                <h1>Video Explicativo</h1>
            </v-col>
            <v-col cols="12">
                <video id="video" 
                src="https://escuelakpi.club/archivos_empleados/institucionalizacion.mp4" 
                frameborder="0" 
                allowfullscreen
                controls
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                style="width: 100%; height: 100%; background: #FFFFFF;" allowtransparency="true"
                >
              </video>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'VideoExplicativo'
}
</script>